import Vue from 'vue'

export default {
  values: async (period, indicator) => {
    let url = '/plan/' + period.id + '/values'
    if (indicator) {
      url += '/' + indicator.id
    }
    return await Vue.axios.get(url)
  },
  valuesForTeacher: async (period, teacher) => {
    let url = '/plan/' + period.id + '/teacher-values/' + teacher
    return Vue.axios.get(url);
  },
  saveValue: (value) => {
    let formData = new FormData()
    formData.append('indicator', value.indicator.id)
    formData.append('value', value.id)
    Object.keys(value.values).forEach((field) => {
      let _v = value.values[field]
      if (Array.isArray(_v)) {
        _v = _v.map((_i) => {
          return _i.id
        })
      }
      formData.append('fields['+field+']', JSON.stringify(_v))
    })
    return Vue.axios.post('/plan/' + value.period + '/values', formData);
  },
  deleteValue: (period, indicator, value) => {
    let formData = new FormData()
    formData.append('indicator', indicator.id)
    formData.append('value', value.id)
    return Vue.axios.post('/plan/' + period + '/values/delete', formData);
  },
  countValue: (period, indicator, value, award, comment) => {
    let formData = new FormData()
    formData.append('indicator', indicator.id)
    formData.append('value', value.id)
    formData.append('award', award)
    formData.append('comment', comment)
    return Vue.axios.post('/plan/' + period + '/values/count', formData);
  },
  savePlannedValue: (period, indicator, plannedValue) => {
    let formData = new FormData()
    formData.append('indicator', indicator.id)
    formData.append('value', plannedValue)

    return Vue.axios.post('/plan/' + period + '/planned', formData)
  }
}
